import { api, unwrap, repeatedParams } from './http';

export default {
  list: async (params = {}) => unwrap(api.get('/Gates', params)),

  getById: async (id) => unwrap(api.get(`/Gates/${id}`)),

  create: async (payload) => unwrap(api.post('/Gates', payload)),

  update: async (id, payload) => unwrap(api.put(`/Gates/${id}`, payload)),

  remove: async (id) => unwrap(api.delete(`/Gates/${id}`)),

  getDeviceTypes: async (params = {}) => unwrap(api.get('/Gates/DeviceTypes', params)),

  // Access control schedule
  listAccessControlSchedules: async (params = {}) => unwrap(api.get('/GateAccessControlSchedule', params)),

  getAccessControlScheduleById: async (id) => unwrap(api.get(`/GateAccessControlSchedule/${id}`)),

  createAccessControlSchedule: async (payload) => unwrap(api.post('/GateAccessControlSchedule', payload)),

  updateAccessControlSchedule: async (id, payload) => unwrap(api.put(`/GateAccessControlSchedule/${id}`, payload)),

  removeAccessControlSchedule: async (id) => unwrap(api.delete(`/GateAccessControlSchedule/${id}`)),

  getAccessControlScheduleGroups: async (id, params = {}) => unwrap(api.get(`/GateAccessControlSchedule/Groups/${id}`, params)),

  updateAccessControlScheduleGroups: async (membershipTypeId, gateIds) => (
    unwrap(api.put(`/GateAccessControlSchedule/Groups/${membershipTypeId}?${repeatedParams('gatesIds', gateIds).toString()}`))
  ),

  updateGateAccessControl: async (gateId, payload) => unwrap(api.post(`/Gates/${gateId}/Update/AccessControl`, payload)),

  listGateAccessControlMembers: async (gateId, params = {}) => unwrap(api.get(`/Gates/${gateId}/Update/AccessControl`, params)),

  createAccessControlScheduleForGate: async (gateId, payload) => unwrap(api.post(`/GateAccessControlSchedule/${gateId}`, payload)),

  updateAccessControlScheduleForGate: async (gateId, payload) => unwrap(api.put(`/GateAccessControlSchedule/${gateId}`, payload)),
};
